import styled from 'styled-components'
import { theme } from "../theme";
import { Logout } from '@mui/icons-material';
import { Link } from './Link';
import { useNavigate } from 'react-router-dom';
import { authenticator } from '../services/Authenticator';

const Container = styled.div`
  height: 100px;
  background-color: ${theme.palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const Logo = styled.img`
  height: 50px;
`

const LogoutButtonContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding-right: ${theme.spacing.md};
`

const LogoutButton = styled.div`
  background-color: rgba(0,0,0,0.1);
  color: rgba(255,255,255,0.7);
  border-radius: 5px;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: ${theme.typography.textSizes.sm};
  cursor: pointer;
  transition: all 0.25s;
  display: flex;
  font-weight: medium;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  &:hover {
    color: white;
    background-color: rgba(0,0,0,0.2);
  }
`

const LogoutText = styled.div`
  padding-right: ${theme.spacing.xxs};
`
 
export function Header() {
  const navigate = useNavigate()

  return (
    <Container>
      <Link to='/'>
        <Logo src={require('../assets/logo.png')} />
      </Link>

      <LogoutButtonContainer>
        <LogoutButton onClick={() => {
          authenticator.logout()
          navigate('/login')
        }}>
          <LogoutText>
            Logout
          </LogoutText>
          <Logout fontSize='small' />
        </LogoutButton>
      </LogoutButtonContainer>
    </Container>
  )
}